import { NavController, NavParams, ModalController,AlertController,LoadingController,ViewController,ToastController } from 'ionic-angular';
import { Component,Input, Output } from '@angular/core';
import {VehiculeInfo,DeviceLabel,CustomSelectInfo,DriverLabel,GroupLabel,Vehicule,Groupe,Driver} from '../../../../objects/index';
import { VehiculeService } from '../../../../providers/vehicule.service';


@Component({
    selector: 'app-vehicule-form',
    templateUrl: 'vehicule-form.html'
})
export class VehiculeForm{
    idDevice: number = 0;

    idDriver: number = 0;
    driver: CustomSelectInfo;
    groupsofVehicule: CustomSelectInfo[] = null;
    devicesToSelect: CustomSelectInfo[] = [];

    device: CustomSelectInfo; 
    email1: string = "";
    email2: string = "";
    email3: string = "";
    email4: string = "";
    email5: string = "";
    vehiculeInfo: VehiculeInfo = null;
    vehicule:VehiculeInfo;
    groupLabels: GroupLabel[] = [];
    groupsToSelect: CustomSelectInfo[] = [];
    selectedItems: any;
    private value: any = {};
    showGroup: Boolean = false;
    idGroups = [];
    showDriver: Boolean = false;
    idtest=[];
    groupName: string = null;
    driverLabels: DriverLabel[] = [];
    driverName: string = null;
    deviceLabels: DeviceLabel[] = [];
    deviceNumber: number;
    request: Boolean = false;
    driversToSelect: CustomSelectInfo[] = [];
    adding: Boolean = false;
    updating: Boolean = false;
    detaills: Boolean = false;
    affecting: Boolean = false;
    mode: number = 0;
    constructor(public navParams: NavParams,private vehiculeService:VehiculeService,public viewCtrl:ViewController,public toastCtrl:ToastController){
        this.vehicule = navParams.get('vehicule');
    }
    ngOnInit() {
        this.groupLabels = this.vehiculeService.groupLabels;
        this.driverLabels = this.vehiculeService.driverLabels;
        if (this.deviceLabels.length == 0) {
            this.request = true;
            this.vehiculeService.getDevicesLabel().subscribe(response => {
                this.deviceLabels = response;
                this.vehiculeService.deviceLabels = response;
                this.customInfoToSelectDevice();
            });
            this.vehiculeService.getGroupsLabel().subscribe(response => {
                this.groupLabels = response;
                this.vehiculeService.groupLabels = response;
                this.customInfoToSelectGroup(this.groupLabels, this.groupsToSelect, true);
            });
            this.vehiculeService.getDriversLabel().subscribe(response => {
            this.driverLabels = response;
            this.vehiculeService.driverLabels = response;
            this.customInfoToSelectDriver();
    
          });
    
        }
        this.vehicule.emails = "";
          let params =this.vehicule.idVehicule;
          this.mode = +params;
            if (!this.request) {
                this.customInfoToSelectGroup(this.groupLabels, this.groupsToSelect, true);
                this.customInfoToSelectDriver();
                this.customInfoToSelectDevice();
                this.showAffecting();
                this.manipulationData(this.mode);
              
            }
          
          else {
            this.showDetaills();
            this.manipulationData(-this.mode);
          }
        
      }
    selectGroup(){
      
        for(var i=0 ; i<this.groupLabels.length;i++){
            for(var j=0;j<this.idtest.length;j++){
                if(this.idtest[j]==this.groupsToSelect[i].text){
                    this.idGroups[j]=this.groupsToSelect[i].id;
                }
            }
        }
        
    }
    public refreshValueGroups(value: any): void {
        this.value = value;
        this.selectedItems = value;
    
      }
      public selectedGroup(value: any): void {
        if (value.id == -1) {
          this.showGroup = true;
          this.showDriver = false;
        }
        else {
          this.idGroups.push(value.id);
     
        }
      }
      public removedGroup(value: any): void {
        this.idGroups = this.idGroups.filter(id => id !== value.id);
      }
      customInfoToSelectGroup(list: GroupLabel[], listPush: CustomSelectInfo[], addOption: Boolean) {
        for (let i = 0; i < list.length; i++) {
          let group = new CustomSelectInfo(list[i].nom, list[i].idGroupe);
          listPush.push(group);
        }
        if (addOption) {
          let group = new CustomSelectInfo("Autres", -1);
          this.groupsToSelect.push(group);
        }   
      }
      closeModal(){
        
        this.viewCtrl.dismiss(null);
    }
    customInfoToSelectDevice() {
        for (let i = 0; i < this.deviceLabels.length; i++) {
          let device = new CustomSelectInfo(this.deviceLabels[i].idDevice.toString(), this.deviceLabels[i].idDevice);
          this.devicesToSelect.push(device);
        }
      }
      customInfoToSelectDriver() {
        for (let i = 0; i < this.driverLabels.length; i++) {
          let driver = new CustomSelectInfo(this.driverLabels[i].firstName, this.driverLabels[i].idDriver);
          this.driversToSelect.push(driver);
        }
        let driver = new CustomSelectInfo("Autres", -1);
        this.driversToSelect.push(driver);
      }
      public showAdd() {
        this.adding = true;
        this.updating = false;
        this.detaills = false;
        this.affecting = false;
      }
      public showUpdate() {
        this.adding = false;
        this.updating = true;
        this.detaills = false;
        this.affecting = false;
      }
      public showDetaills() {
        this.adding = false;
        this.updating = false;
        this.detaills = true;
        this.affecting = false;
      }
      public showAffecting() {
        this.adding = false;
        this.updating = false;
        this.detaills = false;
        this.affecting = true;
      }
      manipulationData(id: number) {
        this.vehiculeInfo = this.vehicule;
        if (this.vehiculeInfo == null)
          this.vehiculeService.getOne(id)
            .subscribe(response => {
                
              this.vehiculeInfo = response;
              this.config(this.vehicule, this.vehiculeInfo);
              this.deviceNumber = this.vehiculeInfo.device.deviceNumber;
             console.log(this.deviceNumber)

              this.formatEmails(this.vehiculeInfo);
              if (this.vehiculeInfo.idDriver > 0)
                this.driver = new CustomSelectInfo(this.vehiculeInfo.lastName, this.vehiculeInfo.idDriver);
              this.device = new CustomSelectInfo(this.vehiculeInfo.device.deviceNumber.toString(), this.vehiculeInfo.device.idDevice);
              this.idDevice = response.device.idDevice;
              this.idDriver = response.idDriver;
            });
        this.vehiculeService.getGroupsVehicule(id)
          .subscribe(response => {
            this.groupsofVehicule = [];
            this.customInfoToSelectGroup(response, this.groupsofVehicule, false);
            for (let i = 0; i < response.length; i++) {
              if (response[i].idGroupe != 1) {
                this.idGroups.push(response[i].idGroupe);
              }
            }
          });
        if (this.vehiculeInfo != null) {
          this.formatEmails(this.vehiculeInfo);
          if (this.vehiculeInfo.idDriver > 0)
            this.driver = new CustomSelectInfo(this.vehiculeInfo.lastName, this.vehiculeInfo.idDriver);
          this.device = new CustomSelectInfo(this.vehiculeInfo.device.deviceNumber.toString(), this.vehiculeInfo.device.idDevice);
          this.config(this.vehicule, this.vehiculeInfo);
        }
      }
      config(vehicule: Vehicule, vehiculeInfo: VehiculeInfo) {
        this.idDevice = vehiculeInfo.device.idDevice;
        this.idDriver = vehiculeInfo.idDriver;
        vehicule.idVehicule = vehiculeInfo.idVehicule;
        vehicule.matricule = vehiculeInfo.matricule;
        vehicule.mark = vehiculeInfo.mark;
        vehicule.alias = vehiculeInfo.alias;
        vehicule.maxSpeed = vehiculeInfo.maxSpeed;
        this.deviceNumber = vehiculeInfo.device.deviceNumber;
    
      }
      formatEmails(vehiculeInfo: VehiculeInfo) {
        let emails = vehiculeInfo.emails;
        if (emails.length > 0)
          this.email1 = emails.slice(0, emails.indexOf(";"));
        emails = emails.substr(emails.indexOf(";") + 1);
        if (emails.length > 0)
          this.email2 = emails.slice(0, emails.indexOf(";"));
        emails = emails.substr(emails.indexOf(";") + 1);
        if (emails.length > 0)
          this.email3 = emails.slice(0, emails.indexOf(";"));
        emails = emails.substr(emails.indexOf(";") + 1);
        if (emails.length > 0)
          this.email4 = emails.slice(0, emails.indexOf(";"));
        emails = emails.substr(emails.indexOf(";") + 1);
        if (emails.length > 0)
          this.email5 = emails.slice(0, emails.indexOf(";") + 1);
      }
      update() {
         this.selectGroup();
        if (this.deviceNumber == null)
          this.deviceNumber = 0;
        if (this.vehicule.maxSpeed >= 0 || this.vehicule.maxSpeed == null) {
          if (this.idDevice != 0) {
            this.vehiculeService.update(this.vehicule, this.idGroups.toString(), this.idDriver, this.deviceNumber).subscribe((response) => {
              this.vehiculeService.toastyUpdate = true;
              let toast = this.toastCtrl.create({
                message: ''+this.vehicule.matricule+' est modifié avec succés',
                duration: 3000,
                position: 'top'
              });
              toast.present();
              this.viewCtrl.dismiss(null);
            }, () => { 
                let toast = this.toastCtrl.create({
                    message: 'Opération échouée',
                    duration: 3000,
                    position: 'top'
                  });
                  toast.present();
            });
          } else {
            let toast = this.toastCtrl.create({
                message: ' Veuillez selectionnée un boitier',
                duration: 3000,
                position: 'top'
              });
            
              toast.present();
          }
        } else {
            let toast = this.toastCtrl.create({
                message: 'Vitesse max doit-etre supérieure  à 0',
                duration: 3000,
                position: 'top'
              });
            
              toast.present();
        }
      }
    ionViewWillLeave(){
        
    }
}



// WEBPACK FOOTER //
// ./src/pages/datamana/vehicules/vehicule-form/vehicule-form.ts